module.exports = __webpack_public_path__ + "media/images/icons/icons_large/34_airbaloon-ad235cc9e8a78756ca26ec30357bc1ca.png";